import { FC, memo } from 'react';
import styled from 'styled-components';
import { Container } from '../../../styles/container.styled';
import { StyledSection } from '../../../styles/section.styled';

const LegalPage: FC = () => {
    return (
        <StyledLegalPage>
            <StyledSection>
                <Container>
                    <StyledContent>
                        <StyledBackLink href="/">вернуться назад</StyledBackLink>
                        
                        <StyledTitle>Положение об обработке персональных данных</StyledTitle>

                        <StyledSectionTitle>ОБЩИЕ ПОЛОЖЕНИЯ</StyledSectionTitle>
                        <StyledParagraph>
                            1. Настоящее Положение об обработке персональных данных (далее – Положение, настоящее Положение) разработано <strong>ООО &quot;Транспортная служба XXI век&quot;</strong> (далее также – Оператор) и применяется в соответствии с п. 2 ч. 1 ст. 18.1. Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».<br />
                            Настоящее Положение определяет политику Оператора в отношении обработки персональных данных.<br />
                            Все вопросы, связанные с обработкой персональных данных, не урегулированные настоящим Положением, разрешаются в соответствии с действующим законодательством Российской Федерации в области персональных данных.<br />
                            Настоящее Положение и изменения к нему утверждаются руководителем Оператора и вводятся приказом Оператора.
                        </StyledParagraph>
                        <StyledParagraph>
                            2. В соответствии с п. 1 ст. 3 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» под персональными данными клиентов, физических лиц понимается любая информация, относящаяся к прямо или косвенно определённому или определяемому на основании такой информации клиенту, физическому лицу (далее – персональные данные).
                        </StyledParagraph>
                        <StyledParagraph>
                            3. <strong>ООО &quot;Транспортная служба XXI век&quot;</strong> является оператором, организующим и (или) осуществляющим обработку персональных данных, а также определяющим цели и содержание обработки персональных данных.
                        </StyledParagraph>
                        <StyledParagraph>
                            4. Целью обработки персональных данных является:
                        </StyledParagraph>
                        <StyledList>
                            <li>обеспечение защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну;</li>
                            <li>оказание Оператором физическим и юридическим лицам услуг, связанных с хозяйственной деятельностью Оператора, включая контакты Оператора с такими лицами, в том числе по электронной почте, по телефону, по адресу, предоставленным соответствующим лицом;</li>
                            <li>направление консультаций, ответов обратившимся лицам с помощью средств связи и указанных ими контрактных данных;</li>
                            <li>продвижение товаров, работ, услуг Оператора на рынке путем осуществления прямых контактов с потенциальным потребителем с помощью средств связи (допускается только при условии предварительного согласия субъекта персональных данных).</li>
                        </StyledList>
                        <StyledParagraph>
                            5. Обработка организована Оператором на принципах:
                        </StyledParagraph>
                        <StyledList>
                            <li>законности целей и способов обработки персональных данных, добросовестности и справедливости в деятельности Оператора;</li>
                            <li>достоверности персональных данных, их достаточности для целей обработки, недопустимости обработки персональных данных, избыточных по отношению к целям, заявленным при сборе персональных данных;</li>
                            <li>обработки только персональных данных, которые отвечают целям их обработки;</li>
                            <li>соответствия содержания и объема обрабатываемых персональных данных заявленным целям обработки. Обрабатываемые персональные данные не должны быть избыточными по отношению к заявленным целям их обработки;</li>
                            <li>недопустимости объединения баз данных, содержащих персональные данные, обработка которых осуществляется в целях, не совместимых между собой;</li>
                            <li>обеспечения точности персональных данных, их достаточности, а в необходимых случаях и актуальности по отношению к целям обработки персональных данных. Оператор принимает необходимые меры либо обеспечивает их принятие по удалению или уточнению неполных или неточных данных;</li>
                            <li>хранения персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных.</li>
                        </StyledList>
                        <StyledParagraph>
                            6. Обработка персональных данных осуществляется с соблюдением принципов и правил, предусмотренных Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и настоящим Положением.
                        </StyledParagraph>
                        <StyledParagraph>
                            7. Персональные данные обрабатываются с использованием и без использования средств автоматизации.
                        </StyledParagraph>
                        <StyledParagraph>
                            8. В соответствии с поставленными целями и задачами Оператор до начала обработки персональных данных назначает ответственного за организацию обработки персональных данных.
                        </StyledParagraph>
                        <StyledList>
                            <li>Ответственный за организацию обработки персональных данных получает указания непосредственно от исполнительного органа Оператора и подотчетен ему.</li>
                            <li>Ответственный за организацию обработки персональных данных вправе оформлять и подписывать уведомление, предусмотренное ч. 1 и 3 ст. 22 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</li>
                        </StyledList>
                        <StyledParagraph>
                            9. Сотрудники Оператора, непосредственно осуществляющие обработку персональных данных, должны быть ознакомлены с положениями законодательства Российской Федерации о персональных данных, в том числе с требованиями к защите персональных данных, а также с настоящим Положением.
                        </StyledParagraph>

                        <StyledSectionTitle>СОСТАВ ПЕРСОНАЛЬНЫХ ДАННЫХ</StyledSectionTitle>
                        <StyledParagraph>
                            1. Оператор обрабатывает следующие категории персональных данных клиентов:
                        </StyledParagraph>
                        <StyledList>
                            <li>фамилия, имя, отчество;</li>
                            <li>дата рождения;</li>
                            <li>адрес регистрации и адрес фактического проживания;</li>
                            <li>номер телефона;</li>
                            <li>адрес электронной почты;</li>
                            <li>реквизиты документа, удостоверяющего личность;</li>
                            <li>иные персональные данные, предоставленные клиентом.</li>
                        </StyledList>
                        <StyledParagraph>
                            2. Оператор не обрабатывает специальные категории персональных данных, касающиеся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни.
                        </StyledParagraph>

                        <StyledSectionTitle>ЦЕЛИ И СПОСОБЫ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</StyledSectionTitle>
                        <StyledParagraph>
                            1. Обработка персональных данных осуществляется в следующих целях:
                        </StyledParagraph>
                        <StyledList>
                            <li>исполнение договоров, стороной которых является клиент;</li>
                            <li>осуществление связи с клиентом, в том числе направление уведомлений, запросов и информации, касающихся использования услуг Оператора, а также обработка запросов и заявок от клиента;</li>
                            <li>улучшение качества услуг Оператора;</li>
                            <li>проведение статистических и иных исследований на основе обезличенных данных;</li>
                            <li>реклама и маркетинг (только при наличии согласия субъекта персональных данных).</li>
                        </StyledList>
                        <StyledParagraph>
                            2. Обработка персональных данных осуществляется следующими способами:
                        </StyledParagraph>
                        <StyledList>
                            <li>сбор персональных данных;</li>
                            <li>запись персональных данных;</li>
                            <li>систематизация персональных данных;</li>
                            <li>накопление персональных данных;</li>
                            <li>хранение персональных данных;</li>
                            <li>уточнение (обновление, изменение) персональных данных;</li>
                            <li>извлечение персональных данных;</li>
                            <li>использование персональных данных;</li>
                            <li>передача (распространение, предоставление, доступ) персональных данных;</li>
                            <li>обезличивание персональных данных;</li>
                            <li>блокирование персональных данных;</li>
                            <li>удаление персональных данных;</li>
                            <li>уничтожение персональных данных.</li>
                        </StyledList>

                        <StyledSectionTitle>ОБЯЗАТЕЛЬСТВА ОПЕРАТОРА</StyledSectionTitle>
                        <StyledParagraph>
                            1. Оператор обязуется:
                        </StyledParagraph>
                        <StyledList>
                            <li>не сообщать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом;</li>
                            <li>принимать необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования, предоставления, распространения, а также от иных неправомерных действий в отношении персональных данных;</li>
                            <li>опубликовать или иным образом обеспечить неограниченный доступ к настоящему Положению об обработке персональных данных;</li>
                            <li>назначить ответственного за организацию обработки персональных данных;</li>
                            <li>осуществлять внутренний контроль соответствия обработки персональных данных Федеральному закону от 27.07.2006 № 152-ФЗ «О персональных данных» и принятым в соответствии с ним нормативным правовым актам, требованиям к защите персональных данных, настоящему Положению;</li>
                            <li>в случае выявления неправомерной обработки персональных данных в срок, не превышающий 3 рабочих дней с даты этого выявления, прекратить неправомерную обработку персональных данных или обеспечить прекращение неправомерной обработки персональных данных;</li>
                            <li>в случае если цель обработки персональных данных достигнута, прекратить обработку персональных данных или обеспечить её прекращение и уничтожить персональные данные или обеспечить их уничтожение в срок, не превышающий 30 дней с даты достижения цели обработки персональных данных, если иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных, иным соглашением между Оператором и субъектом персональных данных, либо если Оператор не вправе осуществлять обработку персональных данных без согласия субъекта персональных данных по основаниям, предусмотренным Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» или другими федеральными законами;</li>
                            <li>в случае отзыва субъектом персональных данных согласия на обработку его персональных данных прекратить обработку персональных данных или обеспечить прекращение такой обработки и в случае если сохранение персональных данных более не требуется для целей обработки персональных данных, уничтожить персональные данные или обеспечить их уничтожение в срок, не превышающий 30 дней с даты поступления указанного отзыва, если иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных, иным соглашением между Оператором и субъектом персональных данных, либо если Оператор не вправе осуществлять обработку персональных данных без согласия субъекта персональных данных по основаниям, предусмотренным Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» или другими федеральными законами;</li>
                            <li>уведомить субъекта персональных данных или его представителя о том, что обработка персональных данных, осуществляемая Оператором, привела к нарушению требований Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» или принятых в соответствии с ним нормативных правовых актов, в срок, не превышающий 3 рабочих дней с даты выявления указанного нарушения;</li>
                            <li>хранить информацию о фактах доступа к персональным данным не менее 1 года;</li>
                            <li>осуществлять иные обязанности, предусмотренные Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».</li>
                        </StyledList>
                        <StyledParagraph>
                            2. Оператор при обработке персональных данных клиента обязуется:
                        </StyledParagraph>
                        <StyledList>
                            <li>обрабатывать только те персональные данные, которые необходимы для выполнения конкретных функций;</li>
                            <li>не запрашивать информацию о состоянии здоровья клиента, за исключением тех сведений, которые относятся к вопросу о возможности выполнения клиентом обязательств по договору с Оператором;</li>
                            <li>передавать персональные данные клиента его представителям в порядке, установленном Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».</li>
                        </StyledList>

                        <StyledSectionTitle>ДОСТУП К ПЕРСОНАЛЬНЫМ ДАННЫМ</StyledSectionTitle>
                        <StyledParagraph>
                            1. Право доступа к персональным данным имеют:
                        </StyledParagraph>
                        <StyledList>
                            <li>руководитель Оператора;</li>
                            <li>работающие с определённым клиентом работники Оператора;</li>
                            <li>работники бухгалтерии;</li>
                            <li>работники, осуществляющие техническое обеспечение деятельности Оператора.</li>
                        </StyledList>
                        <StyledParagraph>
                            2. Клиенты в целях обеспечения защиты персональных данных имеют следующие права:
                        </StyledParagraph>
                        <StyledList>
                            <li>на полную информацию об их персональных данных и обработке этих данных;</li>
                            <li>на свободный бесплатный доступ к своим персональным данным, включая право на получение копий любой записи, содержащей персональные данные, за исключением случаев, предусмотренных федеральным законом;</li>
                            <li>на определение своих представителей для защиты своих персональных данных;</li>
                            <li>на требование об исключении или исправлении неверных или неполных персональных данных, а также данных, обработанных с нарушением требований Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</li>
                        </StyledList>
                        <StyledParagraph>
                            3. Копировать и делать выписки персональных данных разрешается исключительно в служебных целях с разрешения руководителя.
                        </StyledParagraph>

                        <StyledSectionTitle>ОТВЕТСТВЕННОСТЬ ЗА НАРУШЕНИЕ НОРМ, РЕГУЛИРУЮЩИХ ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</StyledSectionTitle>
                        <StyledParagraph>
                            1. Лица, виновные в нарушении порядка обращения с персональными данными, несут дисциплинарную, административную, гражданско-правовую или уголовную ответственность в соответствии с федеральными законами.
                        </StyledParagraph>
                        <StyledParagraph>
                            2. Руководители структурных подразделений Оператора несут персональную ответственность за исполнение обязанностей их подчиненными.
                        </StyledParagraph>

                        <StyledTitle>Согласие на обработку персональных данных</StyledTitle>
                        <StyledParagraph>
                            Пользователь, оставляя обращение, заявку на сайте{' '}
                            <a href="https://osobennoe-taxi.ru/" target="_blank" rel="noopener noreferrer">
                                https://osobennoe-taxi.ru/
                            </a>{' '}
                            (далее также – сайт), создавая аккаунт и/или соглашаясь с офертой на сайте, принимает настоящее Согласие на обработку персональных данных.
                        </StyledParagraph>
                        <StyledParagraph>
                            Пользователь, действуя свободно, своей волей и в своём интересе, подтверждая свою дееспособность, даёт своё согласие <strong>ООО &quot;Транспортной службе XXI век&quot;</strong> (ИНН7802324316, ОГРН 1057810410041, <strong>адрес: Санкт-Петербург, пр. Большой Сампсониевский д 45</strong>) на обработку своих персональных данных как с использованием, так и без использования средств автоматизации для целей обработки входящих запросов физических лиц (пользователей) с целью консультирования, направления комментариев физическим лицам (пользователям); аналитики действий физического лица (пользователя) на сайте и функционирования сайта; выполнения обязательств по договору оферты, принятому пользователем на сайте. При этом:
                        </StyledParagraph>
                        <StyledList>
                            <li>Согласие предоставлено для использования моих следующих персональных данных: Фамилия, имя, отчество; номера контактных телефонов; адреса электронной почты; место работы и занимаемая должность; адрес; сведения о местоположении; тип, версия, язык операционной системы, браузера; тип устройства и разрешение его экрана; страницы, открываемые пользователем; ip-адрес.</li>
                            <li>Обработка моих персональных данных может включать следующие действия: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение.</li>
                        </StyledList>
                        <StyledParagraph>
                            Настоящее согласие может быть отозвано путём направления субъектом персональных данных (пользователем) или его представителем письменного заявления по адресу: <strong>ООО &quot;Транспортная служба XXI век, 194044 Санкт-Петербург, пр. Большой Сампсониевский д.45</strong> либо по адресу электронной почты: <strong>ts@mc21.ru</strong>. В случае отзыва субъектом персональных данных (пользователем) согласия на обработку персональных данных <strong>ООО &quot;Транспортная служба XXI век&quot;</strong> вправе продолжить обработку таких персональных данных в случаях, предусмотренных пунктами 2-11 части 1 статьи 6, пунктами 2-10 части 2 статьи 10, части 2 статьи 11 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».
                        </StyledParagraph>
                        <StyledParagraph>
                            Настоящее согласие предоставляется на неопределённый срок и действует весь период обработки персональных данных. Запросы относительно персональных данных могут быть направлены по электронному адресу: <strong>ts@mc21.ru</strong>
                        </StyledParagraph>
                    </StyledContent>
                </Container>
            </StyledSection>
        </StyledLegalPage>
    );
};

const StyledLegalPage = memo(styled.div`
    min-height: 100vh;
    padding: 40px 0;
`);

const StyledContent = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    line-height: 1.4;
    color: var(--color-text);

    @media (max-width: 992px) {
        padding: 16px;
    }
`;

const StyledBackLink = styled.a`
    display: block;
    margin-bottom: 24px;
    color: var(--color-primary-blue);
    text-decoration: none;
    font-size: 16px;
    transition: var(--transition);
    text-align: center;

    &:hover {
        opacity: 0.7;
        text-decoration: underline;
    }
`;

const StyledTitle = styled.h1`
    font-size: 28px;
    font-weight: 700;
    margin: 24px 0;
    color: var(--color-text);
    text-align: center;

    @media (max-width: 992px) {
        font-size: 24px;
    }
`;

const StyledSectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    margin: 32px 0 16px 0;
    color: var(--color-text);
    text-align: center;

    @media (max-width: 992px) {
        font-size: 18px;
    }
`;

const StyledParagraph = styled.p`
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: 12px;
    color: var(--color-text);

    strong {
        font-weight: 700;
    }

    a {
        color: var(--color-primary-blue);
        text-decoration: underline;
        
        &:hover {
            opacity: 0.7;
        }
    }

    @media (max-width: 992px) {
        font-size: 14px;
    }
`;

const StyledList = styled.ul`
    margin: 16px 0;
    padding-left: 0;
    list-style: none;

    li {
        position: relative;
        font-size: 16px;
        line-height: 1.4;
        margin-bottom: 8px;
        padding-left: 24px;
        color: var(--color-text);

        &::before {
            content: '•';
            position: absolute;
            left: 0;
            color: var(--color-text);
            font-size: 18px;
            line-height: 1.4;
        }

        @media (max-width: 992px) {
            font-size: 14px;
        }
    }
`;

export default memo(LegalPage);

